/* ============================================================
   KHS MOBILE GALLERY behaviour (own elements, khsg-*).
   - swipe the strip (native scroll-snap)
   - tap a thumbnail -> scroll main strip to that image
   - scrolling updates the counter + active thumbnail underline
   - press & hold on the active image -> zoom at finger (no popup)
   Mobile only; guarded.
   ============================================================ */
(function () {
  'use strict';

  var ZOOM = 2.6;
  var HOLD_MS = 160;
  var MOVE_CANCEL = 12;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function initGallery(root) {
    if (!root || root.__khsgBound) return;
    root.__khsgBound = true;

    var track = root.querySelector('.khsg__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.khsg__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.khsg__thumb'));
    var counterCur = root.querySelector('.khsg__counter-cur');
    if (!track || slides.length === 0) return;

    var current = 0;

    function setActive(index) {
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      current = index;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      if (counterCur) counterCur.textContent = index + 1;
    }

    // --- thumbnail click -> scroll main strip to that slide ---
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var slide = slides[i];
        if (!slide) return;
        // center the slide in the viewport
        var left = slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2;
        track.scrollTo({ left: left, behavior: 'smooth' });
        setActive(i);
        // keep the tapped thumb in view
        thumb.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      });
    });

    // --- scrolling the strip updates the active index (counter + thumb) ---
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        // find the slide whose center is closest to the viewport center
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, i) {
          var sc = s.offsetLeft + s.clientWidth / 2;
          var d = Math.abs(sc - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        if (best !== current) setActive(best);
      });
    }, { passive: true });

    // --- press & hold zoom on each slide's image ---
    slides.forEach(function (slide) {
      var img = slide.querySelector('.khsg__img');
      if (!img) return;

      var holdTimer = null;
      var zooming = false;
      var moved = false;
      var startX = 0, startY = 0;

      function pointPct(e) {
        var t = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
        var r = slide.getBoundingClientRect();
        return {
          x: Math.max(0, Math.min(100, ((t.clientX - r.left) / r.width) * 100)),
          y: Math.max(0, Math.min(100, ((t.clientY - r.top) / r.height) * 100))
        };
      }
      function apply(p) {
        img.style.transformOrigin = p.x + '% ' + p.y + '%';
        img.style.transform = 'scale(' + ZOOM + ')';
      }
      function start(e) {
        zooming = true;
        slide.classList.add('khsg-zooming');
        root.classList.add('khsg-anyzoom');
        apply(pointPct(e));
      }
      function end() {
        if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
        if (!zooming) return;
        zooming = false;
        img.style.transform = '';
        slide.classList.remove('khsg-zooming');
        root.classList.remove('khsg-anyzoom');
      }

      slide.addEventListener('touchstart', function (e) {
        if (!isMobile() || e.touches.length !== 1) return;
        moved = false;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        holdTimer = setTimeout(function () {
          holdTimer = null;
          if (!moved) start(e);
        }, HOLD_MS);
      }, { passive: true });

      slide.addEventListener('touchmove', function (e) {
        if (!isMobile()) return;
        var t = e.touches[0];
        if (!zooming) {
          if (Math.abs(t.clientX - startX) > MOVE_CANCEL || Math.abs(t.clientY - startY) > MOVE_CANCEL) {
            moved = true;
            if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; } // let the swipe happen
          }
          return;
        }
        e.preventDefault();       // lock scroll while zooming
        apply(pointPct(e));
      }, { passive: false });

      slide.addEventListener('touchend', end, { passive: true });
      slide.addEventListener('touchcancel', end, { passive: true });

      // Stop the iOS Safari long-press callout ("Save Image / Copy / Share")
      // and image dragging — these were interrupting the hold-to-zoom.
      slide.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      img.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    setActive(0);
  }

  function initAll() {
    document.querySelectorAll('.khsg').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
